export * from './industry-list.component';